import { PropsWithChildren } from 'react';

import { ModuleConfigContext } from './ModuleConfigProvider.context';

const defaultValue = {};

export const ModuleConfigProvider = <C,>({ children, value }: PropsWithChildren<{ value: C }>) => {
  return <ModuleConfigContext.Provider value={value ?? defaultValue}>{children}</ModuleConfigContext.Provider>;
};
